export default class AdBlockDetector {
  static adBlockerEnabled(){
    var img = document.querySelector('.ads img');
    return img ? window.getComputedStyle(img, null).display == 'none' : false;
  }
}
